import axios from "../../axiosInstance";

// Picks on orders, the same ones the warehouse app makes (Bolt Locations,
// /api/wms). The route sheet's tick boxes: a tick picks what is left on a
// line with no spot; unticking undoes those picks. Every write carries a
// request_id, so a tap sent twice is saved once.

const send = async (request) => {
  let response = { data: null, error: null };
  try {
    const res = await request();
    response = { ...response, data: res.data };
  } catch (error) {
    response = { ...response, error: error };
  }
  return response;
};

const requestId = () => {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return `web-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
};

// What is picked on each line of these orders (up to 100):
// { orders: [{ id, warehouse_id, lines: [{ order_detail_id, ordered, picked,
// remaining, picks: [{ movement_id, quantity, source, located, by }] }] }],
// missing: [order ids the login can't see] }.
export const fetchPicks = (orderIds) =>
  send(() =>
    axios.get(`wms/picks`, { params: { order_ids: orderIds.join(",") } }),
  );

// Picks `quantity` of an order line with no spot ("not recorded").
export const pickLine = (orderId, warehouseId, orderDetailId, quantity) =>
  send(() =>
    axios.post(`wms/orders/${orderId}/pick`, {
      request_id: requestId(),
      warehouse_id: warehouseId,
      order_detail_id: orderDetailId,
      quantity,
    }),
  );

// Undoes one pick (what is still open of it).
export const unpickMovement = (orderId, warehouseId, movementId) =>
  send(() =>
    axios.post(`wms/orders/${orderId}/unpick`, {
      request_id: requestId(),
      warehouse_id: warehouseId,
      movement_id: movementId,
    }),
  );
